import axios from "axios";
import getHeaders from "../constants/headers";
import { STORE_BASE_URL } from "./BaseURL";

export const CheckGeoConfigAccess = (data) => {
  return axios({
    method: "post",
    url:
      STORE_BASE_URL +
      "/brand/api/secure/v1/check-geo-config-access",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getBrandGeoConfig = (brandId) => {
    return axios({
        method: "get",
        url: STORE_BASE_URL + "/brand/api/secure/v1/brand/" + brandId + "/geo-config",
        headers: getHeaders(),
    });
};